import { template } from 'lodash';
import axios from './client';

const WIDGET_REAL = template('/widgets/real/<%= pageId %>');
const WIDGET_REAL_MAIL = template('widgets/real/<%= pageId %>/mail');
const WIDGET_PAYMENT_CALCULATOR = template('/widgets/payment-calculator/<%= pageId %>');
const WIDGET_PAYMENT_CALCULATOR_MAIL = template('widgets/payment-calculator/<%= pageId %>/mail');
const BANNERS = '/widgets/banners';
const BANNER = template('/widgets/banner/<%= id %>');
const BANNER_MAIL = template('/widgets/banner/<%= id %>/mail');
const SHOW_BLOCK = '/widgets/full-page/show';
const FULL_PAGE = template('/widgets/full-page/<%= pageId %>');
const FULL_PAGE_MAIL = template('/widgets/full-page/<%= pageId %>/mail');

/**
 * TODO: это какое то безумие
 * TODO: МОЖНО БУКВАЛЬНО ТАК, форм дата по сути и есть такая строка при запросе.... XD
 * TODO: new URLSearchParams(formData).toString();
 * @param formData
 * @returns {Promise<AxiosResponse<any>>}
 */
export function realWidgetCode(formData) {
  // Не надо так...
  const pageId = formData.get('pageId');
  const userId = formData.get('userId');
  const color1 = formData.get('color1');
  const color2 = formData.get('color2');
  const color3 = formData.get('color3');
  const widthbtn = formData.get('widthbtn');
  const textButton = formData.get('textButton');
  const hideLink = formData.get('hideLink');
  const paramsPart1 = `?userId=${userId}&color1=${color1}&color2=${color2}`;
  const paramsPart2 = `&color3=${color3}&widthbtn=${widthbtn}&textButton=${textButton}`;
  const paramsPart3 = `&hideLink=${hideLink}`;
  const params = paramsPart1 + paramsPart2 + paramsPart3;
  return axios.get(WIDGET_REAL({ pageId }) + params, { responseType: 'json' });
}

export function realWidgetSendToEmail(formData) {
  const pageId = formData.get('pageId');
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(WIDGET_REAL_MAIL({ pageId }), formData, { headers });
}

export function paymentCalculatorWidgetCode(payload) {
  const { pageId } = payload;
  return axios.get(WIDGET_PAYMENT_CALCULATOR({ pageId }), { params: payload, timeout: 0 });
}

export function paymentCalculatorSendToEmail(formData) {
  const pageId = formData.get('pageId');
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(WIDGET_PAYMENT_CALCULATOR_MAIL({ pageId }), formData, { headers });
}

export function banners(params) {
  return axios.get(BANNERS, { params, timeout: 0 });
}

export function banner(id, params) {
  return axios.get(BANNER({ id }), { params, timeout: 0 });
}

export function bannerSendToEmail(id, params) {
  return axios.post(BANNER_MAIL({ id }), params);
}

export function showBlock(userId = null) {
  let param = '';
  if (userId) {
    param = `?userId=${userId}`;
  }
  return axios.get(SHOW_BLOCK + param, { timeout: 0 });
}

export function fullPage(formData) {
  const pageId = formData.get('pageId');
  const userId = formData.get('userId');
  const color1 = formData.get('color1');
  const color2 = formData.get('color2');
  const coBrandedColor = formData.get('coBrandedColor');
  const hideLink = formData.get('hideLink');
  const params = `?userId=${userId}&color1=${color1}&color2=${color2}&coBrandedColor=${coBrandedColor}&hideLink=${hideLink}`;
  return axios.get(FULL_PAGE({ pageId }) + params, { timeout: 0 });
}

export function fullPageSendToEmail(params) {
  const pageId = params.get('pageId');
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(FULL_PAGE_MAIL({ pageId }), params, { headers });
}
